import { ReactElement } from 'react'
import { Product } from './campaign'

export enum WizardModeEnum {
  BASIC,
  ADVANCED,
}

export enum WizardGroupEnum {
  BRAND_AWARENESS,
  WEBSITE_TRAFFIC,
  CONVERSIONS,
  E_COMMERCE,
  VIDEO,
  CONTENT_MARKETING,
}

export enum WizardCategoryEnum {
  DISPLAY_CAMPAIGNS,
  FLATFEE_CAMPAIGNS,
  VIDEO_CAMPAIGNS,
  CONTENT_MARKETING,
  PRODUCT_CAMPAIGNS,
  CLASSIC_CAMPAIGNS,
  MAILING_CAMPAIGNS,
  PERFORMANCE_ORDER,
}

export enum WizardSubCategoryEnum {
  MIX = 'MIX',
  STICKY = 'STICKY',
  STICKY_AD = 'STICKY_AD',
  FLAT_FEE = 'FLAT_FEE',
  FLAT_FEE_PUBLISHER = 'FLAT_FEE_PUBLISHER',
  VIDEO = 'VIDEO',
  COMMERCIAL_BREAK = 'COMMERCIAL_BREAK',
  GIGABOARD = 'GIGABOARD',
  ARTICLE_NATIVE = 'ARTICLE_NATIVE',
  ARTICLE_SPONSORED = 'ARTICLE_SPONSORED',
  DISPLAY_DYNAMIC = 'DISPLAY_DYNAMIC',
  MAILING_PROSPECTING = 'MAILING_PROSPECTING',
  RETARGETING = 'RETARGETING',
  ROAS = 'ROAS',
  DISPLAY = 'DISPLAY',
  DISPLAY_CPM = 'DISPLAY_CPM',
  NATIVE = 'NATIVE',
  MAILING = 'MAILING',
  MAILING_CPM = 'MAILING_CPM',
  PUBLISHERS_DISPLAY = 'PUBLISHERS_DISPLAY',
  BROAD_FLEX = 'BROAD_FLEX',
  WP_FLEX = 'WP_FLEX',
  SCREENING = 'SCREENING',
  START_PAUSE_AD = 'START_PAUSE_AD',
  PERFORMANCE_ORDER = 'PERFORMANCE_ORDER',
  OUTSTREAM_IN_BANNER = 'OUTSTREAM_IN_BANNER',
  SCREENING_PUBLISHER = 'SCREENING_PUBLISHER',
}

export type WizardSubCategory = {
  id: WizardSubCategoryEnum
  name: string
  description: {
    value: string
    parameters?: {
      label: string
      value: string
    }[]
  }
  detailedDescription: string | ReactElement
  productsSectionTitle?: string
  products: Product[]
  wpBooster?: boolean
  cost?: number
  icons: string[]
}

export type WizardCategory = {
  id?: WizardCategoryEnum
  name?: string
  description?: string
  Icon?: ReactElement
  subCategory: WizardSubCategory[]
}

export type WizardGroup = {
  id: WizardGroupEnum
  name: string
  description: string
  Icon: ReactElement
  category: WizardCategory[]
}
